import React, { useState } from 'react';
import { Layout } from 'antd';
import { useScroll, useMotionValueEvent } from 'framer-motion';
import { useNavigate } from 'react-router-dom';
import { Navigation } from '../components/Navigation';
import { AccessibleButton } from '../components/AccessibleButton';
import { AccessibleImage } from '../components/AccessibleImage';
import { scrollToTop } from '../utils/navigation';
import Beta from '../../public/img/svg/beta.svg';

const { Header: AntHeader } = Layout;

export const Header: React.FC = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const { scrollY } = useScroll();
  const navigate = useNavigate();

  // Détecter le scroll pour activer/désactiver les effets visuels
  useMotionValueEvent(scrollY, "change", (latest) => {
    setIsScrolled(latest > 0);
  });

  const handleLogoClick = (event: React.MouseEvent) => {
    event.preventDefault();
    navigate('/');
    scrollToTop();
  };

  return (
    <AntHeader 
      id="header-navigation"
      className="z-[10] bg-transparent px-0 h-auto relative w-full" 
      role="banner"
      tabIndex={-1}
    >  
      <div className="flex justify-self-center fixed z-[10] w-full max-w-[1440px] bg-transparent mx-auto px-15 py-2 flex justify-center items-center">
        <div 
          className={`w-full flex mx-auto justify-between items-center px-5 py-3 rounded-2xl overflow-hidden transition-all duration-300 ease-out border-1 ${isScrolled ? 'bg-neutral-white/85 backdrop-blur-lg border-1 shadow-sm' : 'backdrop-blur-0 border-transparent shadow-0'}`}
        >
          <a 
            href="/" 
            className="text-xl font-bold !text-neutral-black gap-2 flex items-center no-underline hover:opacity-80 transition-opacity duration-200"
            aria-label="Retour à la page d'accueil d'AndyK.app"
            onClick={handleLogoClick}
          >
            <AccessibleImage 
              src="/img/svg/logo-header.svg" 
              altKey="images.logo"
              className="h-8"
            />
            <span>AndyK.app</span>
            <div style={{borderRadius:'5px',fontSize:'10px',border:'#432DCD solid 2px', padding:'0px 6px', fontWeight:'bold',color:'#432DCD',textTransform:'lowercase'}}>Beta</div>
          </a>
          
          <Navigation />
          
          <AccessibleButton 
            type="secondary" 
            ariaLabelKey="navigation.supportProject"
          >
            Soutenir le projet
          </AccessibleButton>
        </div>
        
      </div>
    </AntHeader>
  );
};